const dataSensores = [

    {
        name: "Sensor de CO 1",
        description: "598",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 2",
        description: "599",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 3",
        description: "600",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 4",
        description: "601",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 5",
        description: "602",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 6",
        description: "603",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 7",
        description: "604",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 8",
        description: "605",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
    {
        name: "Sensor de CO 9",
        description: "606",
        image: require("../../../assets/img/devices/sensorCO.png"),

    },
  
]

export default dataSensores;